import axios from "axios";
import Cookies from "js-cookie";


export const host = "https://ftcdc.udru.ac.th/ftcdc-api/api/";
export const hostImg =
  "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/Product/";
//  export const host = "https://wildlifesanctuaryfca16.com/api/";

export const AxiosGet = async (path, params) => {
  try {
    let res = await axios.get(host + path, {
      params: params,
    });
    return res;
  } catch (error) {
    return error.response;
  }
};

export const AxiosGetToken = async (path = "", params) => {
  try {
    const cookies = Cookies.get('TokenAdmin');
    const token = cookies;
    let res = await axios.get(host + path, {
      headers: { Authorization: "Bearer " + token },
      params: params,
    });
    console.log("AxiosGetToken", res);
    return res;
  } catch (error) {
    if(error?.response?.data?.error=='An error while decoding token.'){
      Cookies.remove('TokenAdmin')
    }
    return error.response;
  }
};

export const AxiosPost = async (path = "", data, params) => {
  try {
    let res = await axios.post(host + path, data, {
      params: params,
    });
    console.log("AxiosPost", res);
    return res;
  } catch (error) {
    console.log("AxiosPost error", error?.response ?? error);
    return error.response;
  }
};

export const AxiosPostToken = async (path = "", data, params) => {
  try {
    const cookies = Cookies.get('TokenAdmin');
    const token = cookies;
    let res = await axios.post(host + path, data, {
      headers: { Authorization: "Bearer " + token },
      params: params,
    });
    return res;
  } catch (error) {
    if(error?.response?.data?.error=='An error while decoding token.'){
      Cookies.remove('TokenAdmin')
    }
    return error.response;
  }
};

export const AxiosPostFormData = async (path = "", data, params) => {
  try {
    let res = await axios.post(host + path, data, {
      headers: { "Content-Type": "multipart/form-data" },
      params: params,
    });
    return res;
  } catch (error) {
    return error.response;
  }
};

export const AxiosPostFormDataToken = async (path = "", data, params) => {
  try {
    const cookies = Cookies.get('TokenAdmin');
    const token = cookies;
    let res = await axios.post(host + path, data, {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
      params: params,
    });
    return res;
  } catch (error) {
    if(error?.response?.data?.error=='An error while decoding token.'){
      Cookies.remove('TokenAdmin')
    }
    return error.response;
  }
};

export const AxiosPutFormDataToken = async (path = "", data, params) => {
  try {


    const cookies = Cookies.get('TokenAdmin');
    const token = cookies;
    let res = await axios.put(host + path, data, {
      headers: { Authorization: token, "Content-Type": "multipart/form-data" },
      params: params,
    });
    return res;
  } catch (error) {
    if(error?.response?.data?.error=='An error while decoding token.'){
      Cookies.remove('TokenAdmin')
    }
    return error.response;
  }
};

export const AxiosPutToken = async (path = "", data, params) => {
  try {
    const cookies = Cookies.get('TokenAdmin');
    const token = cookies;
    let res = await axios.put(host + path, data, {
      headers: { Authorization: "Bearer " + token },
      params: params,
    });
    return res;
  } catch (error) {
    if(error?.response?.data?.error=='An error while decoding token.'){
      Cookies.remove('TokenAdmin')
    }
    return error.response;
  }
};

export const AxiosDeleteToken = async (path = "", params) => {
  try {


    const cookies = Cookies.get('TokenAdmin');
    const token = cookies;
    let res = await axios.delete(host + path, {
      headers: { Authorization: "Bearer " + token },
      params: params,
    });
    return res;
  } catch (error) {
    if(error?.response?.data?.error=='An error while decoding token.'){
      Cookies.remove('TokenAdmin')
    }
    return error.response;
  }
};
